import { parseISO } from 'date-fns'
import { DATE_FORMAT_LOCALES, SUPPORTED_LANGUAGES } from 'src/constants/locale'

export const formatLocalizedDate = (date: string, language: string) => {
  // `new Date('YYYY-MM-DD')` parses as UTC midnight, which renders as the previous
  // day in timezones behind UTC. `parseISO` treats date-only strings as local time.
  const parsedDate = parseISO(date)
  if (language.startsWith(SUPPORTED_LANGUAGES.ES)) {
    return (
      new Intl.DateTimeFormat(DATE_FORMAT_LOCALES.ES, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
        .formatToParts(parsedDate)
        // Add periods to Spanish Intl output:
        // "4 feb 2026" -> "4 feb. 2026"
        // "15 abr 2026" -> "15 abr. 2026"
        // "28 nov 2026" -> "28 nov. 2026"
        .map((part) =>
          part.type === 'month' && !part.value.endsWith('.') ? `${part.value}.` : part.value,
        )
        .join('')
    )
  }

  return new Intl.DateTimeFormat(DATE_FORMAT_LOCALES.EN, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(parsedDate)
}
